<mat-card flex="100">
  <mat-card-title>
    {{ (airCarrier$ | async)?.abbreviation }} Transmission Runs
    <button mat-raised-button (click)="refresh()">
      <mat-icon>refresh</mat-icon>
    </button>
    <button
      *ngIf="airCarrier$ | async; let airCarrier"
      mat-raised-button
      (click)="queue(airCarrier.id)"
      mat-button
    >
      Queue New Run
    </button>
  </mat-card-title>
  <mat-divider></mat-divider>
  <mat-divider></mat-divider>
  <mat-card-content>
    <div
      fxLayout="row wrap"
      fxLayoutGap="10px"
      fxLayoutAlign="start start"
      [formGroup]="transmissionRunParameters"
    >
      <mat-form-field>
        <input matInput formControlName="searchTerm" placeholder="Search" />
        <button
          mat-button
          *ngIf="transmissionRunParameters.controls.searchTerm.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
          (click)="transmissionRunParameters.controls.searchTerm.reset()"
        >
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          formControlName="startTime"
          [matDatepicker]="startPicker"
          [max]="transmissionRunParameters.controls.endTime.value"
          placeholder="Start date"
        />
        <mat-datepicker-toggle matSuffix [for]="startPicker"></mat-datepicker-toggle>
        <mat-datepicker #startPicker></mat-datepicker>
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          formControlName="endTime"
          [matDatepicker]="endPicker"
          [min]="transmissionRunParameters.controls.startTime.value"
          placeholder="End date"
        />
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker></mat-datepicker>
      </mat-form-field>
    </div>
    <div>
      <ng-template
        [flLoading]="loadingKey"
        [flLoadingUntil]="transmissionRuns$ | async"
        flLoadingStrategy="overlay"
        flLoadingColor="primary"
      >
        <table mat-table [dataSource]="transmissionRuns$" fxFlex="100">
          <ng-container matColumnDef="requestedDate">
            <th mat-header-cell *matHeaderCellDef>Requested Date</th>
            <td mat-cell *matCellDef="let transmissionRun">
              {{ (transmissionRun.requestedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="queuedDate">
            <th mat-header-cell *matHeaderCellDef>Queued Date</th>
            <td mat-cell *matCellDef="let transmissionRun">
              {{ (transmissionRun.queuedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="processedDate">
            <th mat-header-cell *matHeaderCellDef>Processed Date</th>
            <td mat-cell *matCellDef="let transmissionRun">
              {{ (transmissionRun.processedDate | date : 'MM/dd/yyyy HH:mm') || '--' }}
            </td>
          </ng-container>
          <ng-container matColumnDef="processingState">
            <th mat-header-cell *matHeaderCellDef>Processing State</th>
            <td mat-cell *matCellDef="let transmissionRun">
              {{ transmissionRun.processingState | humanize }}
            </td>
          </ng-container>
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let transmissionRun">
              <button mat-icon-button [matMenuTriggerFor]="transmissionRunActions">
                <mat-icon>more_vert</mat-icon></button
              ><mat-menu #transmissionRunActions="matMenu">
                <a mat-menu-item routerLink="{{ transmissionRun.id }}">
                  <mat-icon>assignment</mat-icon>View
                </a>
              </mat-menu>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>
      </ng-template>
    </div>
    <div>
      <mat-paginator
        [pageSize]="pageSize$ | async"
        [pageIndex]="pageIndex$ | async"
        [pageSizeOptions]="pageSizeOptions"
        [length]="total$ | async"
        (page)="onPage($event)"
      >
      </mat-paginator>
    </div>
  </mat-card-content>
</mat-card>
